import Component from 'classes/Component'
export default class AgeCheck extends Component {
    constructor() {
        super({
            id: 'ageCheck',
            element: '.ageCheck',
            elements: {
                ageCheck_button_yes: '.ageCheck_button_yes',
                ageCheck_button_no: '.ageCheck_button_no'
            }
        })

        this.checkFor18Years();
        this.createInteractions();
    }

    checkFor18Years(){

        if (document.querySelector("html").classList.contains("page-wines","page-product") ||
            document.querySelector("html").classList.contains("page-product")) {
            if(!this.getCookie('ageCheck')){
                console.log("noCookie");
                document.getElementById("ageChecker").classList.add("visible");
            }
        }
    }

    createInteractions = () => {
        this.elements.ageCheck_button_yes.addEventListener('click', this.closeAgeChecker)
        this.elements.ageCheck_button_no.addEventListener('click', this.redirectToHome)
    }

    closeAgeChecker = () => {
        this.setCookie('ageCheck',true,30);
        document.getElementById("ageChecker").classList.remove("visible");
    }

    redirectToHome = () => {
        window.location.href = "/";
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        //console.log("cookie added",cname,cvalue,exdays);
    }


    //verify Booking Cookies
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

}
